var React = require('react');

function FancyArrowLeftInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M8.22473 7.58923C8.22473 11.9221 4.76625 15.4347 0.5 15.4347V15.7142V15.9938V16.518V16.7976V17.0771C4.76625 17.0771 8.22473 20.5897 8.22473 24.9226H9.2914C9.2914 21.3141 7.18375 18.2056 4.15052 16.7976L32.5 16.7976V15.7142L4.15053 15.7142C7.18375 14.3062 9.2914 11.1977 9.2914 7.58923H8.22473Z","fill":"currentColor"}));
}

FancyArrowLeftInline.defaultProps = {"className":"w-full h-auto pointer-events-none","viewBox":"0 0 33 33","fill":"none"};

module.exports = FancyArrowLeftInline;

FancyArrowLeftInline.default = FancyArrowLeftInline;
